import React, { useEffect, useContext, useState } from "react"
import PricingPlanCard from "./PricingPlanCard"
import useLoading from "../../hooks/useLoading"
import { SubscriptionContext } from "../subscription/SubscriptionContext"
import { SubscriptionRequests } from "../../api/app.service"
import { UserCtx } from "../../context/userContext"
import { useToast } from "../../hooks/useToast"

const MarketingPlans: React.FC = () => {
  const [selectedPlan, setSelectedPlan] = useState<"monthly" | "annual">(
    "annual"
  )
  const { toast } = useToast()
  const [hideSecondaryNav, setHideSecondaryNav] = useState(false)
  const [showSubscription, setShowSubscription] = useState(true)
  const [showReceipts, setShowReceipts] = useState(false)
  const [trialActive, setTrialActive] = useState(false)
  const [paymentMethods, setPaymentMethods] = useState([])
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null)
  const [paymentMethodModal, setPaymentMethodModal] = useState(null)
  const [subscription, setSubscription] = useState(null)
  const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false)
  const [showSubscriptionCheckout, setShowSubscriptionCheckout] =
    useState(false)
  const [options, setOptions] = useState(null)
  const [selectedSubscription, setSelectedSubscription] = useState(null)
  const [plans, setPlans] = useState([])
  const [isSubscriptionUpdate, setIsSubscriptionUpdate] = useState(false)
  const [getSubscription, setGetSubscription] = useState(() => () => {})
  const { user } = useContext(UserCtx)
  const { startLoading, stopLoading } = useLoading()
  const [delayedGetPaymentMethods, setDelayedGetPaymentMethods] = useState(
    () => () => {}
  )
  const [assignSelectedPaymentMethod, setAssignSelectedPaymentMethod] =
    useState(() => () => {})
  const [showSubscriptionComponents, setShowSubscriptionComponents] =
    useState<any>(null)
  const [showCreatePayment, setshowCreatePayment] = useState<boolean>(false)

  const handleChoosePlanClick = (planType: string) => {
  }

  const SubscriptionContextValues = {
    hideSecondaryNav,
    setHideSecondaryNav,
    showSubscription,
    setShowSubscription,
    showReceipts,
    setShowReceipts,
    trialActive,
    paymentMethods,
    setPaymentMethods,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    paymentMethodModal,
    setPaymentMethodModal,
    subscription,
    setSubscription,
    showSubscriptionPlans,
    setShowSubscriptionPlans,
    showSubscriptionCheckout,
    setShowSubscriptionCheckout,
    showSubscriptionComponents,
    setShowSubscriptionComponents,
    options,
    setOptions,
    selectedSubscription,
    setSelectedSubscription,
    plans,
    setPlans,
    isSubscriptionUpdate,
    setIsSubscriptionUpdate,
    getSubscription,
    delayedGetPaymentMethods,
    assignSelectedPaymentMethod,
    showCreatePayment,
  }

  const grabSubscription = async () => {
    startLoading()
    await SubscriptionRequests.getActiveSubscriptionCoach({
      user_id: parseInt(user.user_id),
    })
      .then((data: any) => {
        if (Object.keys(data.active_subscription).length !== 0) {
          setSubscription(data.active_subscription)
        } else {
          setSubscription(null)
        }
      })
      .catch((ex) => {
        console.error(ex)
        toast.error(ex.response.data.message)
      })
      .finally(() => {
        stopLoading()
      })
  }

  useEffect(() => {
    if (user?.user_id) {
      grabSubscription()
    }
  }, [user])

  return (
    <SubscriptionContext.Provider value={SubscriptionContextValues}>
      <div className="h-full flex flex-col items-center">
        <div className="relative flex justify-center items-center w-full max-w-xs rounded-[20px] border-2 border-black h-[50px] p-1">
          <button
            onClick={() => setSelectedPlan("monthly")}
            className={`w-[40%] h-full rounded-[18px] ${
              selectedPlan === "monthly"
                ? "bg-[black] text-[white]"
                : "bg-white text-blue-500"
            }`}
          >
            Monthly
          </button>
          <button
            onClick={() => setSelectedPlan("annual")}
            className={`w-[60%] h-full rounded-[18px] ${
              selectedPlan === "annual"
                ? "bg-[black] text-[white]"
                : "bg-white text-blue-500"
            }`}
          >
            Annual (Save 16%)
          </button>
        </div>
        {/* Use below for future promos */}
        {/* <div className="mt-8 text-lg text-center">
          <span className="text-blurple font-bold">Only 50 Spots Available:</span> Lifetime 50% Savings! Be one of the first 50 coaches to join and pay half-price forever.
        </div> */}

        <div className="mt-8 flex flex-col sm:flex-row w-full justify-center items-center gap-[10px] xsm:gap-8 sm:px-6 ">
          <PricingPlanCard
            planType="freeTrial"
            handleChoosePlanClick={handleChoosePlanClick}
          />
          <PricingPlanCard
            planType={selectedPlan}
            handleChoosePlanClick={handleChoosePlanClick}
          />
        </div>
      </div>
    </SubscriptionContext.Provider>
  )
}

export default MarketingPlans
